import styled from 'styled-components';

const SmallButtonStyles = styled.div`
    background-color: darkorange;
    width: 75px; 
    position: absolute;
    right: -1px;
    top: -1px;
    text-align: center;
    font-size: 1.5rem;
`;

export default SmallButtonStyles;